module.exports = __webpack_public_path__ + "static/media/flowingwater_img.47345139.png";